const getTextAlignSentence = ({ align }) => {
  if (align) return `text-align: ${align};`;

  return null;
};

export default getTextAlignSentence;
